import { ErrorMessage, Field, useFormikContext } from 'formik';
import { TooltipButton } from '../authentication/SignUp/components/Tooltip';
import { FC, useState } from 'react';


interface FieldWithErrorMessageProps {
  name: string;
  type: string;
  placeholder: string;
  label: string;
  tooltip?: boolean;
  disabled?: boolean;
}

export const FieldWithErrorMessage: FC<FieldWithErrorMessageProps> =
  ({ name, type, placeholder, label, tooltip = false, disabled }) => {

    const { errors, touched } = useFormikContext<Record<string, object>>();
    const [showPassword, setShowPassword] = useState(false);
    const hasLabelContent = Boolean(label) || tooltip;
    const hasError = Boolean(touched[name] && errors[name]);
    return (
  <>
    {hasLabelContent && (
      <div className='flex items-center gap-2'>
        {label && (
          <label
            htmlFor={name}
            className='block font-sans text-sm text-white/80 lg:text-gray-600 mb-2'
          >
            <span className='font-sans'>{label}</span>
          </label>
        )}

        <div>{tooltip && <TooltipButton />}</div>
      </div>
    )}

    <div className='relative mt-1'>
      <Field
        disabled={disabled}
        type={showPassword ? 'text' : type}
        id={name}
        name={name}
        placeholder={placeholder}
        className={`
          font-sans rounded-full 
          text-black placeholder:text-black/50
          bg-white
          ${hasError ? 'input-error' : 'input-primary'}
        `}
      />

      {type === 'password' && (
        <button
          type='button'
          className='absolute right-4 top-1/2 -translate-y-1/2 text-black/70 lg:text-gray-500 font-sans text-sm'
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? 'Ocultar' : 'Ver'}
        </button>
      )}
    </div>

    {hasError && (
      <div className='pl-4 pt-1'>
        <ErrorMessage name={name}>
          {msg => (
            <p className='text-xs font-sans text-orange-400'>
              {msg}
            </p>
          )}
        </ErrorMessage>
      </div>
    )}
  </>
);
  }
